module.exports = __webpack_public_path__ + "img/o.2000a7ad.jpg";